import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import services from '../../services';

const AddBoard = ({ onHide, show, getAllBoard, setBoardName, editId, setEditId }) => {
    const [boardInput, setBoardInput] = useState(setBoardName || '');

    const handleAddBoard = async () => {
        try {
            if (editId) {
                await services.board.UPDATE_BOARD_BY_ID(editId, { boardName: boardInput });
                setBoardInput('');
                setEditId('')
                toast.success('Board Update Successfully');
                getAllBoard();
            } else {
                await services.board.CREATE_BOARD({ boardName: boardInput });
                setBoardInput('');
                toast.success('Board Create Successfully');
                getAllBoard();
            }
        } catch (e) {
            toast.error(e?.response?.data?.message)
            console.error(e);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter ">Add Board</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Control
                    type="text"
                    placeholder="Board Name"
                    value={boardInput}
                    onChange={(e) => setBoardInput(e.target.value.trimStart())}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            if (!boardInput) {
                                toast.warning('Please Enter Board Name');
                                return;
                            }
                            handleAddBoard();
                            onHide();
                        }
                    }}
                    className="board-name-input"
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outlined" color="default" onClick={onHide}>
                    Close
                </Button>
                <Button
                    onClick={() => {
                        if (!boardInput) {
                            toast.warning('Please Enter Board Name');
                            return;
                        }
                        handleAddBoard();
                        onHide();
                    }}
                >
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddBoard;
